'use client';

import { useTranslations } from '@fshr/context/i18n-context';
import Alert from '../alert';
import Icon, { IconCloseAlt } from '../icon';
import { useState } from 'react';
import Button from '../button';

const ErrorAlert: React.FC<{ message?: string; showCloseIcon?: boolean }> = props => {
	const t = useTranslations();
	const { message = 'Unexpected error', showCloseIcon = false } = props;
	const [showError, setShowError] = useState(true);

	const handleCloseError = () => {
		setShowError(false);
	};

	return showError ? (
		<Alert intent="error" kind="subtle" icon={<Icon icon="alert" />}>
			{showCloseIcon ? (
				<div className="flex flex-row w-full justify-between items-between text-caption">
					{t(message)}
					<Button
						intent="unstyled"
						type="button"
						onClick={handleCloseError}
						aria-label={t('Close button')}
					>
						<IconCloseAlt width={15} height={15} />
					</Button>
				</div>
			) : (
				<span className="text-caption">{t(message)}</span>
			)}
		</Alert>
	) : null;
};

export default ErrorAlert;
